import { createFileRoute } from '@tanstack/react-router';
import { featureGuard } from 'router/featureGuard';
import { JwtFeature } from 'utility/jwt';

export const Route = createFileRoute('/_authenticated/planning/schedule')({
  beforeLoad: featureGuard(JwtFeature.Activity),
});
